import { supabase } from '../auth/supabase'

/**
 * Season So Far, exactly as season_so_far() returns it.
 *
 * Reads the SERVER, unlike the Stats screen which reads the scorer's local
 * events -- so a teammate who only watches still sees the season. One source of
 * truth; no recomputation here.
 */

export interface LeaderPlayer {
  name: string
  total: number
  per_game: number
  series: number[]
}
export interface Leaderboard {
  stat_type: string
  full_name: string
  players: LeaderPlayer[]
}
export interface Improvement {
  name: string
  stat_type: string
  full_name: string
  recent_avg: number
  season_avg: number
  delta: number
}
export interface TrendRow {
  game_number: number
  date: string
  round: string | null
  opponent: string | null
  result: 'W' | 'L' | 'D' | null
  totals: Record<string, number> | null
}
export interface ByResult {
  stat_type: string
  full_name: string
  won_avg: number | null
  lost_avg: number | null
}
export interface OpponentRow {
  opponent_name: string | null
  played: number
  won: number
  lost: number
  drawn: number
  averages: Record<string, number> | null
}
export interface LadderRow {
  position: number
  team_name: string
  is_us: boolean
  played: number | null
  won: number | null
  lost: number | null
  drawn: number | null
  points_for: number | null
  points_against: number | null
  competition_points: number | null
}
export interface SeasonSoFar {
  season: { name: string; grade_name: string | null }
  games_scored: number
  leaderboards: Leaderboard[]
  most_improved: Improvement[]
  team_trend: TrendRow[]
  by_result: ByResult[]
  opponents: OpponentRow[]
  ladder: LadderRow[]
  our_position: number | null
  grading_note: string
  finals: { round: string | null; opponent: string | null; date: string; status: string; result: string | null; our_score: number | null; their_score: number | null }[]
  next_fixture: { round: string | null; opponent: string | null; date: string; home_away: string; venue_name: string | null; court_name: string | null } | null
  error?: string
}

export type SeasonResult = { ok: true; data: SeasonSoFar } | { ok: false; error: string }

export async function fetchSeasonSoFar(): Promise<SeasonResult> {
  if (!supabase) return { ok: false, error: 'No backend configured' }
  const { data, error } = await supabase.rpc('season_so_far')
  if (error) return { ok: false, error: error.message }
  const s = data as SeasonSoFar
  if (s?.error) return { ok: false, error: s.error }
  return { ok: true, data: s }
}
